// NPM Imports
import React from "react";
import { FixedSizeList as List } from "react-window";
import InfiniteLoader from "react-window-infinite-loader";

/**
 *  <InfiniteListLoader /> :: used to render list items on scroll
 *  1. have to pass the follwoing porps
 *    - 'listContainerWidth' & 'listContainerHeight' of the list container
 *    - 'listItemHeight'      : heigth of individual list item
 *    - 'itemsList'           : items list array
 *    - 'loadMore()'          : callback for fetching the items on scroll
 *    - 'getListComponent()'  : callback to return the 'List' component
 *    - 'hasNextPage'         : has more items indicator
 *    - 'offset'              : offset value to fetch the next items
 *  2. used the "react-window" & "react-window-infinite-loader" for rendering purpose
 *     read more "https://addyosmani.com/blog/react-window/"
 */

const InfiniteListLoader = props => {
  const {
    itemsList,
    loadMore,
    hasNextPage,
    offset,
    listItemHeight,
    listContainerWidth,
    listContainerHeight,
  } = props;

  // If there are more items to be loaded then add an extra row to hold a loading indicator.
  const itemCount = hasNextPage ? itemsList.length + 1 : itemsList.length;

  // Every row is loaded except for our loading indicator row.
  const isItemLoaded = index => !hasNextPage || index < itemsList.length;

  // Render an list item or a loading indicator.
  const Row = ({ index, style }) => {
    let label;
    if (!isItemLoaded(index)) {
      label = (
        <div style={style} className="infinitelistloader-loader-wrapper">
          <span className="infinitelistloader-loader">loading....</span>
        </div>
      );
    } else {
      label = props.getListComponent(style, itemsList[index]);
    }
    return (
      <div className="infinitelistloader-itemlist" style={style}>
        {label}
      </div>
    );
  };

  return (
    <InfiniteLoader
      isItemLoaded={isItemLoaded}
      itemCount={itemCount}
      loadMoreItems={() => loadMore(offset)}>
      {({ onItemsRendered, ref }) => (
        <List
          height={listContainerHeight}
          width={listContainerWidth}
          itemCount={itemCount}
          itemSize={listItemHeight}
          className="infinitelistloader-container"
          onItemsRendered={onItemsRendered}
          ref={ref}>
          {Row}
        </List>
      )}
    </InfiniteLoader>
  );
};

export default InfiniteListLoader;
